import { Trade } from '@types'

import { Container, Label } from './TradeTag.styled'

interface Props {
  trade: Trade
  backgroundColor?: string
}

export const TradeTag = (props: Props): JSX.Element => {
  const { trade, backgroundColor: customBackgroundColor } = props

  const backgroundColor = customBackgroundColor || trade.color || 'black'
  const shortLabel = trade.shortLabel || trade.label.substring(0, 3).toUpperCase()
  const color = trade.color == '#FDB833' ? 'black' : 'white'

  return (
    <Container style={{ backgroundColor }}>
      <Label style={{ color }}>{shortLabel}</Label>
    </Container>
  )
}
